import UserActionTypes from "./auth.types";

const initialState = {
  isAuthenticated: false,
  jwtToken: "",
  userId: "",
  userEmail: "",
  userFirstname: "",
  userLastname: "",
  userPhone: "",
  userPicture: "",
  userProfile: "",
  userCompany: "",
  currentError: null,
  currentErrorRegister: null,
};

export default function authReducer(state = initialState, { type, payload }) {
  switch (type) {
    case UserActionTypes.SIGN_UP_START:
    case UserActionTypes.SIGN_IN_START:
    case UserActionTypes.SIGN_OUT_SUCCESS:
      return {
        ...state,
        jwtToken: "",
        userEmail: "",
        userFirstname: "",
        userLastname: "",
        userPhone: "",
        userPicture: "",
        userProfile: "",
        userCompany: "",
        userId: "",
        currentError: null,
        isAuthenticated: false,
      };

    case UserActionTypes.COMFIRM_START:
    case UserActionTypes.CHECK_EMAIL_START:
      return {
        ...state,
        jwtToken: "",
        currentError: null,
        currentErrorRegister: null,
      };

    case UserActionTypes.SIGN_IN_SUCCESS:
      return {
        ...state,
        currentError: null,
        jwtToken: payload.signInUserSession.accessToken.jwtToken,
        userId: payload.attributes.sub,
        userEmail: payload.attributes.email,
        userFirstname: payload.attributes.given_name,
        userLastname: payload.attributes.family_name,
        userPhone: payload.attributes.phone_number,
        userPicture: payload.attributes.picture,
        userProfile: payload.attributes.profile,
        userCompany: payload.attributes.website,
        isAuthenticated: true,
      };
    case UserActionTypes.SIGN_UP_SUCCESS:
      return {
        ...state,
        currentError: null,
        userEmail: payload.user.username,
        userId: payload.userSub,
        isAuthenticated: true,
      };

    case UserActionTypes.COMFIRM_FAILURE:
    case UserActionTypes.SIGN_IN_FAILURE:
    case UserActionTypes.SIGN_OUT_FAILURE:
    case UserActionTypes.PROFILE_SET_FAILURE:
    case UserActionTypes.CHECK_EMAIL_FAILURE:
    case UserActionTypes.CONFIRM_PASSWORD_FAILURE:
    case UserActionTypes.CHANGE_PASSWORD_FAILURE:
    case UserActionTypes.CHANGE_EMAIL_FAILURE:
      return {
        ...state,
        currentError: payload,
      };
    case UserActionTypes.SIGN_UP_FAILURE:
      return {
        ...state,
        currentErrorRegister: payload,
      };
    default:
      return state;
  }
}
